import { Component, input } from '@angular/core';
import { FieldTree, FormField } from '@angular/forms/signals';
import { JunoInput, JunoTextarea } from '@dss-libs/shared/ui/common-components';
import { IOrderMessageFormModel } from '@dss-libs/portal/type/portal-types';

@Component({
  selector: 'dss-libs-feature-order-message',
  imports: [FormField, JunoInput, JunoTextarea],
  templateUrl: './order-message.component.html',
  styleUrl: './order-message.component.css',
})
export class OrderMessageComponent {
  readonly form = input.required<FieldTree<IOrderMessageFormModel>>();
}
